/* Where to send someone after they sign in.
   Huedata Academy (/hueex, /learn) is a static page outside this app. Its sign-in
   and sign-up links store the page they came from in localStorage
   "hd_return_to" (raw key, not the ls. prefix), or pass ?return=/hueex/...
   Only same-site paths under /hueex or /learn are honoured, so this cannot be
   used as an open redirect. A stored value older than 7 days is ignored. */
angular.module('app').service('returnToService', ['$location', function ($location) {
  var KEY = 'hd_return_to', AT = 'hd_return_to_at', MAX_AGE = 7 * 864e5;

  function safe(p) {
    if (typeof p !== 'string') return null;
    p = p.trim();
    if (!/^\/(hueex|learn)(\/|#|\?|$)/.test(p)) return null;
    if (/[\\\s]/.test(p) || p.indexOf('//') > -1) return null;
    return p;
  }
  function fromQuery() {
    var q = null;
    try { q = ($location.search() || {}).return; } catch (e) {}
    if (!q) { try { q = new URLSearchParams(window.location.search).get('return'); } catch (e) {} }
    return safe(q);
  }
  function fromStore() {
    try {
      var at = Number(window.localStorage.getItem(AT));
      if (at && Date.now() - at > MAX_AGE) { clear(); return null; }
      return safe(window.localStorage.getItem(KEY));
    } catch (e) { return null; }
  }
  function clear() {
    try { window.localStorage.removeItem(KEY); window.localStorage.removeItem(AT); } catch (e) {}
  }

  /* Keep a ?return= across the sign-up -> verify email -> first login trip. */
  this.remember = function () {
    var q = fromQuery();
    if (q) { try { window.localStorage.setItem(KEY, q); window.localStorage.setItem(AT, String(Date.now())); } catch (e) {} }
  };
  this.peek = function () { return fromQuery() || fromStore(); };
  /* After a successful sign-in: leave the app for the stored page. Returns
     true when it redirected, so the caller skips its own $state.go. */
  this.go = function () {
    var to = this.peek();
    if (!to) return false;
    clear();
    window.location.href = to;
    return true;
  };
}]);
